import { getImage } from '@/assets/images/index';
import { importProjectStyles } from '@/apps';
importProjectStyles();
import '@/assets/styles/base.less';

import directive from '@/directive';

import i18n from '@/lang';

import router from '@/router/index.js';

import store from '@/store';

import eventBus from '@/utils/eventbus';

import Antd, { message } from 'ant-design-vue';

import 'ant-design-vue/dist/antd.less';

import * as THREE from 'three';

import Vue from 'vue';

import VueClipboard from 'vue-clipboard2';

import VXETable from 'vxe-table';

import 'vxe-table/lib/style.css';

import App from './App.vue';

import EventTracking from './utils/event-tracking';

import { importSMBStyles } from '@smb/styles';

importSMBStyles({
  'color-scheme': 'light'
});

window.THREE = THREE;

Vue.config.productionTip = false;

message.config({
  duration: 2, // 持续时间
  top: `100px`, // 到页面顶部距离
  maxCount: 1 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});

Vue.use(Antd);
Vue.use(VXETable);
Vue.use(VueClipboard);
Vue.use(directive);
Vue.use(EventTracking);
Vue.prototype.getImage = getImage;
Vue.prototype.$eventBus = eventBus; // eventBugs
Vue.prototype.$message = message;

Vue.mixin({
  computed: {
    /**
     * 根据当前语言环境返回对应的弹出框位置映射关系解决阿拉伯等rtl排版下拉框等位置问题
     * @returns {Object} 弹出框位置映射关系
     * @returns {String} start - 开始位置
     * @returns {String} end - 结束位置
     * @returns {String} topStart - 顶部开始位置
     * @returns {String} topEnd - 顶部结束位置
     * @returns {String} bottomStart - 底部开始位置
     * @returns {String} bottomEnd - 底部结束位置
     */
    positionMap() {
      const currentLocale = this.$i18n.locale;
      if (['ar', 'he'].includes(currentLocale)) {
        return {
          start: 'right',
          end: 'left',

          topStart: 'topRight',
          topLeft: 'topRight',

          startTop: 'rightTop',
          leftTop: 'rightTop',

          topEnd: 'topLeft',
          topRight: 'topLeft',

          endTop: 'leftTop',
          rightTop: 'leftTop',

          bottomStart: 'bottomRight',
          bottomLeft: 'bottomRight',

          startBottom: 'rightBottom',
          leftBottom: 'rightBottom',

          bottomEnd: 'bottomLeft',
          bottomRight: 'bottomLeft',

          rightBottom: 'leftBottom',
          endBottom: 'leftBottom'
        };
      }

      return {
        start: 'left',
        end: 'right',

        topStart: 'topLeft',
        topLeft: 'topLeft',

        startTop: 'leftTop',
        leftTop: 'leftTop',

        topEnd: 'topRight',
        topRight: 'topRight',

        endTop: 'rightTop',
        rightTop: 'rightTop',

        bottomStart: 'bottomLeft',
        bottomLeft: 'bottomLeft',

        startBottom: 'leftBottom',
        leftBottom: 'leftBottom',

        bottomEnd: 'bottomRight',
        bottomRight: 'bottomRight',

        rightBottom: 'rightBottom',
        endBottom: 'rightBottom'
      };
    }
  }
});

window.vm_project = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
